import styled from '@emotion/styled'

import type { FC } from 'react'

import { css, useTheme } from '@emotion/react'

import Typography from '@segment/matcha/components/Typography'

interface SuccessMessageProps {
  align?: `left` | `center`
}

const copy = {
  message: `Thanks! You'll be hearing from us soon.`,
}

const SuccessMessage: FC<SuccessMessageProps> = ({ align = `center` }) => {
  const theme = useTheme()

  return (
    <Border align={align}>
      <Message variant="pMedium" tokens={{ color: theme.palette.twilio.gray[100] }} align={align}>
        {copy.message}
      </Message>
    </Border>
  )
}

export default SuccessMessage

const Message = styled(Typography)<SuccessMessageProps>`
  margin: 0;
  text-align: ${({ align }) => align};
`

const Border = styled.div<SuccessMessageProps>`
  ${({ align }) =>
    align === `center` &&
    css`
      margin: 0 auto;
    `};

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    width: max-content;
  }
  padding: 32px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.twilio.gray[30]};
`
